export function displaySystemName(system) {
  if (!system) {
    return system;
  }
  const match = String(system).match(/^System\s+(\d+)$/i);
  if (match) {
    return `Hubmaster ${match[1]}`;
  }
  return system;
}

export function renameSystemKeys(obj) {
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) {
    return obj;
  }
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [displaySystemName(key), value])
  );
}

export function formatRole(authority, t) {
  if (!authority) {
    return "";
  }
  const translated = t(authority);
  if (translated && translated !== authority) {
    return translated;
  }
  return authority.replace(/^ROLE_/, "").replaceAll("_", " ");
}

export function formatManagementMethod(name, t) {
  if (!name) {
    return "";
  }
  if (name === "NONE") {
    return t("None");
  }
  return name;
}

export function numberLocale(appLocale) {
  if (appLocale === "es") {
    return "es-ES";
  }
  if (appLocale === "ca") {
    return "ca-ES";
  }
  return "en-US";
}
